import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/patterns/Link'

const PreProdNonLeadMessage = ({ leadSerialNumber }) => (
  <>
    This vehicle is in pre-production and cannot be edited. Switch & Gauge
    settings can be modified on the fleet lead:{' '}
    <Link
      to={`/vehicles/${leadSerialNumber}/summary`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {leadSerialNumber}
    </Link>
  </>
)

PreProdNonLeadMessage.propTypes = {
  leadSerialNumber: PropTypes.string.isRequired,
}

export default PreProdNonLeadMessage
